import { render, staticRenderFns } from "./PaginaPreview.vue?vue&type=template&id=783303c4&scoped=true&"
import script from "./PaginaPreview.vue?vue&type=script&lang=ts&"
export * from "./PaginaPreview.vue?vue&type=script&lang=ts&"
import style0 from "./PaginaPreview.vue?vue&type=style&index=0&id=783303c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "783303c4",
  null
  
)

export default component.exports